import styled from 'styled-components';

import { translate } from '../../../common/helpers/translate.helper';
import { theme } from '../../../common/ui/theme';
import { Text } from '../../Text/Text';

interface ClearFiltersProps {
    onClearClick: () => void;
}

const PillWithoutBorder = styled.div`
    height: 24px;
    display: inline-flex;
    align-items: center;
    color: ${theme.colors.foreground.subtle};
    gap: ${theme.space[4]};
    transition: color 125ms;
    cursor: pointer;

    &:hover {
        color: ${theme.colors.foreground.default};
    }
`;

export const ClearFilters = (props: ClearFiltersProps) => {
    return (
        <PillWithoutBorder onClick={props.onClearClick}>
            <Text variant="extraSmall" fontWeight={500} color="accent.foreground">
                {translate('global.clearFilter.clearFilters')}
            </Text>
        </PillWithoutBorder>
    );
};
